import { Download, Expand, ZoomIn, ZoomOut } from "lucide-react";
import { type PropsWithChildren, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../ui/tooltip";

type ToolbarButtonProps = PropsWithChildren<{
  onClick: () => void;
  tooltip: string;
}>;

const ToolbarButton = ({ onClick, children, tooltip }: ToolbarButtonProps) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="ghost" onClick={onClick} size="sm">
            {children}
          </Button>
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

const DownloadButton = ({
  url,
}: {
  url: string;
}) => {
  const { t } = useTranslation();

  const handleDownload = async () => {
    try {
      const a = document.createElement("a");
      a.href = url;
      a.download = "rechnung.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <ToolbarButton onClick={handleDownload} tooltip={t("download")}>
      <Download width={20} />
    </ToolbarButton>
  );
};

type Props = {
  height?: number;
  pdfBlob: string;
  toolbar?: boolean;
};

export const SimplePdfViewer = ({ height, pdfBlob, toolbar = true }: Props) => {
  const { t } = useTranslation();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  return (
    <iframe
      ref={iframeRef}
      title="pdf viewer"
      src={`${pdfBlob}#toolbar=${toolbar ? "1" : "0"}&navpanes=0&scrollbar=0`}
      height={height ?? "100%"}
      width={"100%"}
    />
  );
};
